/* ==========================================================================
   31st — Conversion helpers
   Countdown, copy-to-clipboard, scroll-to-cart and UGC video playback.
   Vanilla, no dependencies, all optional.
   ========================================================================== */
(function () {
  'use strict';

  var S = (window.st31 && window.st31.strings) || {};

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ------------------------------------------------------------- countdown */
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function formatRemaining(ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var h = Math.floor(total / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;
    return h > 0 ? h + ':' + pad(m) + ':' + pad(s) : pad(m) + ':' + pad(s);
  }

  function resolveDeadline(el) {
    var mode = el.getAttribute('data-mode');

    if (mode === 'fixed') {
      var raw = (el.getAttribute('data-deadline') || '').trim();
      if (!raw) return null;
      // Accept "2026-12-24 18:00" as well as full ISO
      var parsed = Date.parse(raw.replace(' ', 'T'));
      return isNaN(parsed) ? null : parsed;
    }

    // Per-visitor: remembered for the tab so it does not restart on every view
    var key = el.getAttribute('data-key') || 'st31-countdown';
    var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 20;
    var stored = null;
    try { stored = sessionStorage.getItem(key); } catch (e) {}

    var deadline = stored ? parseInt(stored, 10) : NaN;
    if (isNaN(deadline) || deadline < Date.now()) {
      deadline = Date.now() + minutes * 60 * 1000;
      try { sessionStorage.setItem(key, String(deadline)); } catch (e) {}
    }
    return deadline;
  }

  function initCountdown(el) {
    if (el.dataset.ready === 'true') return;

    var deadline = resolveDeadline(el);
    var out = el.querySelector('[data-st31-countdown-time]');
    if (!out) return;

    if (deadline === null) {
      // A real-deadline timer with no date set stays out of the way
      el.hidden = true;
      return;
    }

    el.dataset.ready = 'true';

    function tick() {
      var left = deadline - Date.now();
      if (left <= 0) {
        var expired = el.getAttribute('data-expired');
        if (expired) {
          el.setAttribute('data-expired-state', 'true');
          out.textContent = expired;
          var label = el.querySelector('.st31-countdown__label');
          if (label) label.hidden = true;
        } else {
          el.hidden = true;
        }
        clearInterval(timer);
        return;
      }
      out.textContent = formatRemaining(left);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  /* -------------------------------------------------- copy discount code */
  function flashCopied(btn) {
    var textEl = btn.querySelector('[data-st31-copy-text]');
    var status = btn.closest('[data-st31-promo]');
    status = status && status.querySelector('[data-st31-copy-status]');

    var copied = btn.getAttribute('data-copied-label') || 'Copied!';
    var original = btn.dataset.originalText || (textEl && textEl.textContent);
    if (textEl && !btn.dataset.originalText) btn.dataset.originalText = textEl.textContent;

    btn.setAttribute('data-copied', 'true');
    if (textEl) textEl.textContent = copied;
    if (status) status.textContent = copied;

    clearTimeout(btn._st31Timer);
    btn._st31Timer = setTimeout(function () {
      btn.removeAttribute('data-copied');
      if (textEl) textEl.textContent = btn.dataset.originalText || original;
      if (status) status.textContent = '';
    }, 1800);
  }

  function copyCode(btn) {
    var code = btn.getAttribute('data-st31-copy') || '';
    if (!code) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { flashCopied(btn); }, function () { fallbackCopy(code, btn); });
    } else {
      fallbackCopy(code, btn);
    }
  }

  function fallbackCopy(code, btn) {
    var ta = document.createElement('textarea');
    ta.value = code;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:absolute;left:-9999px;top:0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); flashCopied(btn); } catch (e) {}
    ta.remove();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-st31-copy]');
    if (btn) { e.preventDefault(); copyCode(btn); }
  });

  /* ------------------------------------------------ sticky bar → main ATC */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-st31-scroll-to-atc]');
    if (!btn) return;
    e.preventDefault();

    var target = document.querySelector('[data-st31-atc-anchor]');
    if (!target) return;

    var header = document.querySelector('[data-st31-header][data-sticky="true"]');
    var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
    var top = window.scrollY + target.getBoundingClientRect().top - offset;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });

    // Land focus on the real button so keyboard users continue from there
    var mainBtn = target.querySelector('[data-st31-add]');
    if (!mainBtn) return;
    window.setTimeout(function () {
      mainBtn.focus({ preventScroll: true });
      mainBtn.setAttribute('data-st31-pulse', 'true');
      window.setTimeout(function () { mainBtn.removeAttribute('data-st31-pulse'); }, 900);
    }, reduce ? 0 : 420);
  });

  /* ------------------------------------------------------- UGC video slots */
  function initVideos() {
    var videos = qsa('.st31-pvid__video');
    if (!videos.length) return;

    videos.forEach(function (v) {
      // Belt and braces: some browsers only honour autoplay with these set
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.loop = true;
      v.controls = false;
    });

    if (!('IntersectionObserver' in window)) return;

    // Only play what is on screen — saves battery and data on mobile
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.25 });

    videos.forEach(function (v) { io.observe(v); });
  }

  /* ------------------------------------------------- live viewer count */
  /* Drifts within the merchant's spread rather than sitting on one number.
     The current value is kept in sessionStorage so it stays steady as the
     shopper moves between pages instead of resetting on every load. */
  function initWatching(el) {
    if (el.dataset.ready === 'true') return;

    var base = parseInt(el.getAttribute('data-base'), 10) || 0;
    var spread = parseInt(el.getAttribute('data-spread'), 10) || 0;
    var every = (parseInt(el.getAttribute('data-interval'), 10) || 9) * 1000;
    var out = el.querySelector('[data-st31-watching-value]');
    if (!base || !out) return;

    el.dataset.ready = 'true';

    var min = Math.max(1, base - spread);
    var max = base + spread;
    var key = 'st31-watching-' + (el.getAttribute('data-key') || 'default');

    var current = NaN;
    try { current = parseInt(sessionStorage.getItem(key), 10); } catch (e) {}
    if (isNaN(current) || current < min || current > max) {
      current = min + Math.floor(Math.random() * (max - min + 1));
    }

    function paint(value) {
      if (out.textContent === String(value)) return;
      out.textContent = value;
      el.setAttribute('data-bumped', 'true');
      window.setTimeout(function () { el.removeAttribute('data-bumped'); }, 400);
    }

    function store(value) {
      try { sessionStorage.setItem(key, String(value)); } catch (e) {}
    }

    paint(current);
    store(current);

    if (spread <= 0) return;

    window.setInterval(function () {
      // Small nudge, so it reads like people arriving and leaving
      var step = Math.floor(Math.random() * 5) - 2; // -2..+2
      if (step === 0) step = Math.random() < 0.5 ? -1 : 1;
      current = Math.min(max, Math.max(min, current + step));
      paint(current);
      store(current);
    }, every);
  }

  /* ------------------------------------------------------------------ init */
  function init() {
    qsa('[data-st31-countdown]').forEach(initCountdown);
    qsa('[data-st31-watching]').forEach(initWatching);
    initVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();